var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_31",
    "data-name": "\\uADF8\\uB8F9 31",
    transform: "translate(-545 -170)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_31",
    "data-name": "\\uD0C0\\uC6D0 31",
    transform: "translate(545 170)",
    fill: "rgba(17,17,53,0.37)",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_29",
    "data-name": "\\uADF8\\uB8F9 29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_139",
    "data-name": "\\uC0AC\\uAC01\\uD615 139",
    width: 16,
    height: 26,
    transform: "translate(563 189)",
    fill: "#b761b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_142",
    "data-name": "\\uC0AC\\uAC01\\uD615 142",
    width: 16,
    height: 18,
    transform: "translate(583 205)",
    fill: "#790c79"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_140",
    "data-name": "\\uC0AC\\uAC01\\uD615 140",
    width: 20,
    height: 12,
    transform: "translate(579 189)",
    fill: "#628b8d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_141",
    "data-name": "\\uC0AC\\uAC01\\uD615 141",
    width: 20,
    height: 4,
    transform: "translate(563 219)",
    fill: "#4f7ad9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenPattern);
export default __webpack_public_path__ + "static/media/ben_pattern.d2100b8c76d3cc540c5dc543becbefd9.svg";
export { ForwardRef as ReactComponent };